import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import NoRowsOverlayDataGrid from '../DataGrid/NoRowsOverlay';
import messages from './messages';

const NoRowsSearchOverlay = ({ onClearSearch, searchText = '' }) => (
  <NoRowsOverlayDataGrid
    action={
      <Button color="primary" onClick={onClearSearch} startIcon={<CloseIcon />} sx={{ mt: 3 }} variant="outlined">
        <FormattedMessage {...messages.columnsNoRowsOverlayNoRowsSearchOverlayClearSearch} />
      </Button>
    }
    headerText={<FormattedMessage {...messages.columnsNoRowsOverlayNoRowsSearchOverlayHeaderText} />}
    text={
      <FormattedMessage
        {...messages.columnsNoRowsOverlayNoRowsSearchOverlayText}
        values={{
          br: <br />,
          searchText,
        }}
      />
    }
  />
);

NoRowsSearchOverlay.propTypes = {
  onClearSearch: PropTypes.func.isRequired,
  searchText: PropTypes.string,
};

export default NoRowsSearchOverlay;
